import { render } from "./Header.vue?vue&type=template&id=120c3fc4&bindings={\"isOpen\":\"data\",\"menu\":\"data\",\"isAuthenticated\":\"options\",\"user\":\"options\",\"logout\":\"options\",\"closeMenu\":\"options\"}"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
script.render = render

export default script